import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../integration-store';
import { IDeliverrCredentialsModel } from '../../../../../models/IntegrationsTypes';

class DeliverrCredentialsStore implements ICredentialsStore {
    private _changes: IDeliverrCredentialsModel = {} as IDeliverrCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get apiToken() { return this._changes.api_token; };

    setApiToken(value: string) {
        this._changes.api_token = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default DeliverrCredentialsStore;

